export default "__VITE_ASSET__D$QRCs2p__"